<template>
  <v-footer id="core-footer" absolute height="82" class="flex justify-end">
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://hris.indomaretgroup.com/"
        target="_blank"
      >HRIS</a>&nbsp;
      <v-icon color="tertiary" size="17">mdi-heart</v-icon>
    </span>
  </v-footer>
</template>

<script>
export default {
  name: "CoreFooter"
};
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
